<div *ngIf="showPrimarySpinner" class="spinner-wrapper">
  <mat-spinner class="spinner-inner2"></mat-spinner>
</div>

<div class="content">
  <button
    *ngIf="!isList"
    routerLink="/schools"
    title="{{ 'inputs.back' | translate }}"
    mat-icon-button
  >
    <mat-icon>keyboard_backspace</mat-icon>
    {{ "inputs.back" | translate }}
  </button>
  <div *ngIf="isList" class="card">
    <h1 *ngIf="isList">{{ "titles.list.school" | translate }}</h1>
    <div>
      <mat-form-field *ngIf="isList" style="width: 180px">
        <mat-label>{{ "inputs.search" | translate }}</mat-label>
        <input
          matInput
          (keyup.enter)="changeFilter($event)"
          id="input"
          placeholder="{{ 'inputs.search' | translate }}"
          #input
        />
      </mat-form-field>

      <mat-form-field *ngIf="isList" style="width: 180px; float: right; margin-left: 16px; transform: translate(0px, -2px);">
        <mat-label>{{ "text.notification_type" | translate }}</mat-label>
        <mat-select [(value)]="notificationType">
          <mat-option value="new_photo">{{ "text.notification_order" | translate }}</mat-option>
          <mat-option value="reminder">{{ "text.notification_reminder" | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-raised-button
        matTooltip="{{ 'inputs.send_notifications' | translate }}"
        (click)="sendMassiveNotifications()"
        [disabled]="selection.selected.length<1"
        *ngIf="role == 'superadmin'"
      >
        <span> {{ "inputs.send_notifications" | translate }} </span>
      </button>

      <button
        mat-raised-button
        matTooltip="{{ 'inputs.get_invoices' | translate }}"
        (click)="getMonth()"
        *ngIf="role == 'superadmin'"
      >
        <span> {{ "inputs.get_invoices" | translate }} </span>
      </button>

      <button
        mat-raised-button
        matTooltip="{{ 'inputs.agency_report' | translate }}"
        (click)="getRangeDate()"
        *ngIf="role == 'superadmin'"
      >
        <span> {{ "inputs.agency_report" | translate }} </span>
      </button>
      <!-- <div style="float:right; margin-right: 140px;" *ngIf="role=='superadmin'">
        <button (click)="getRangeDate()" title="{{ 'inputs.agency_report' | translate }}" mat-icon-button >
          {{ 'inputs.get_invoices' | translate }}<mat-icon>document</mat-icon>
        </button>
        <br>
        <button (click)="getRangeDate()" title="{{ 'inputs.agency_report' | translate }}" mat-icon-button >
          {{ 'inputs.agency_report' | translate }}<mat-icon>request_quote</mat-icon>
        </button>
      </div> -->
    </div>

    <div *ngIf="showSchoolprogressSpinner" class="spinner-wrapper">
      <mat-spinner class="spinner-inner"></mat-spinner>
    </div>
    <div *ngIf="isList && dataSource">
      <table mat-table [dataSource]="dataSource.items" matSort>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr
          mat-footer-row
          *matFooterRowDef="['loading']"
          [hidden]="!showSchoolProgressBar"
        ></tr>

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef style="padding-right: 12px;">
              <mat-checkbox style="padding-top: 12px" (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let entity">
              <mat-checkbox style="padding-top: 12px" (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(entity) : null"
                  [checked]="selection.isSelected(entity)">
              </mat-checkbox>
          </td>
      </ng-container>

        <!-- Second Column -->
        <ng-container
          matColumnDef="name"
          *ngIf="role == 'superadmin' || role == 'admin'"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "tables.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)">
            {{ element.name }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="name"
          *ngIf="role != 'superadmin' && role != 'admin'"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "tables.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" style="cursor: default">
            {{ element.name }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="yearperiod"
          *ngIf="role == 'superadmin' || role == 'admin'"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "tables.yearperiod" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" (click)="goTo(element.id)">
            {{ element.yearperiod_name }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="yearperiod"
          *ngIf="role != 'superadmin' && role != 'admin'"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "tables.yearperiod" | translate }}
          </th>
          <td mat-cell *matCellDef="let element" style="cursor: default">
            {{ element.yearperiod_name }}
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="actions" class="actionsColumn">
          <th mat-header-cell *matHeaderCellDef>
            {{ "tables.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <!-- <button (click)="openURL(element.id)" title="open public url" mat-icon-button>
                    <mat-icon>launch</mat-icon>
                </button> -->
            <!-- <button mat-icon-button matTooltip="Click to add Stage" (click)="addStage(element.id)">
                        <mat-icon>playlist_add</mat-icon>
                    </button> -->
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.edit' | translate }}"
              (click)="goTo(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.duplicate_school' | translate }}"
              (click)="duplicate_school(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <!-- <button mat-icon-button matTooltip="Click to replicate School" (click)="replicateSchool(element.id)">
            <mat-icon>content_copy</mat-icon>
          </button> -->

            <button
              mat-icon-button
              matTooltip="{{ 'inputs.upload_excel' | translate }}"
              (click)="uploadStudents(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>upload_file</mat-icon>
            </button>


            <button
              mat-icon-button
              matTooltip="{{ 'text.create_list' | translate }}"
              (click)="getStudentsExcel(element.id, element.name)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>view_list</mat-icon>
            </button>

            <button
              mat-icon-button
              matTooltip="{{ 'inputs.upload_img' | translate }}"
              (click)="uploadImages(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>crop_original</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.process_orders' | translate }}"
              (click)="processOrders(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>check_circle_outline</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.send_notifications' | translate }}"
              (click)="sendNotifications(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>notifications_none</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.send_to_lab' | translate }}"
              [matMenuTriggerFor]="sendTo"
            >
              <mat-icon>science</mat-icon>
            </button>
            <mat-menu #sendTo="matMenu">
              <button mat-menu-item (click)="sendToLab(element.id)">{{ 'inputs.send_to_sinfodigital' | translate }}</button>
              <button mat-menu-item (click)="sendToFtp(element.id)">{{ 'inputs.send_to_ftp' | translate }}</button>
            </mat-menu>
            <!-- <button
              mat-icon-button
              matTooltip="{{ 'inputs.send_to_ftp' | translate }}"
              (click)="sendToFtp(element.id)"
              *ngIf="role == 'superadmin' || role == 'admin'"
            >
              <mat-icon>drive_folder_upload</mat-icon>
            </button> -->
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.school_report' | translate }}"
              (click)="getSchoolReport(element.id)"
              *ngIf="role == 'superadmin' || role == 'school'"
            >
              <mat-icon>school</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.maknetic_report_product' | translate }}"
              (click)="getMakneticReport(element.id, 'product')"
              *ngIf="role == 'superadmin'"
            >
              <mat-icon>inventory_2</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.maknetic_report_student' | translate }}"
              (click)="getMakneticReport(element.id, 'student')"
              *ngIf="role == 'superadmin'"
            >
              <mat-icon>contact_page</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.school_activated' | translate }}"
              (click)="switchActiveOrder(element.id)"
              *ngIf="!element.no_order"
              style="color: #5fbeb5 !important; cursor: default"
            >
              <mat-icon>play_circle_filled</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="{{ 'inputs.school_desactivated' | translate }}"
              (click)="switchActiveOrder(element.id)"
              *ngIf="element.no_order"
              style="cursor: default"
            >
              <mat-icon>pause_circle_filled</mat-icon>
            </button>

            <!-- <button mat-icon-button matTooltip="Click to Delete" class="iconbutton"
                    (click)="goTo(element.uid)" color="warn">
                    <mat-icon>delete</mat-icon>
                </button> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="loading">
          <td mat-footer-cell *matFooterCellDef colspan="6">
            <span>{{ "tables.loading" | translate }}</span>
          </td>
        </ng-container>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">
            {{ "tables.no_data" | translate }}
          </td>
        </tr>
        <!-- <mat-row class="mat-row" *matNoDataRow>
                <mat-cell class="mat-cell" colspan="4">{{ 'tables.no_data' | translate }}</mat-cell>
                </mat-row> -->
      </table>
      <mat-progress-bar
        *ngIf="showSchoolProgressBar"
        mode="indeterminate"
      ></mat-progress-bar>
      <mat-paginator
        [length]="dataSource.meta.totalItems"
        [pageSize]="pageSize"
        [pageIndex] = "pageIndex"
        [pageSizeOptions]="[100, 10, 20, 50]"
        (page)="pageEvent = $event; onPaginateChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>

  <div class="card" *ngIf="!isList">
    <div class="card-content">
      <div class="card-body">
        <h1 *ngIf="!isList && isNew">{{ "titles.edit.school" | translate }}</h1>
        <h1 *ngIf="!isList">{{ school_name }}</h1>
        <div *ngIf="!isList && !isNew">
          <p style="float: left">
            <a [href]="schoolForm.value.school_image" target="_blank"
              ><img [src]="schoolForm.value.school_image"
            /></a>
          </p>
          <p>
            {{ "inputs.creation_date" | translate }}:
            {{ creation_date | date: "d/M/Y, H:mm:ss" }} <br />
            {{ "inputs.modification_date" | translate }}:
            {{ modification_date | date: "d/M/Y, H:mm:ss" }}
          </p>
        </div>
        <div style="clear: left"></div>
        <mat-tab-group
          mat-align-tabs="center"
          #tabGroup
          selectedIndex="[changeTab]"
        >
          <mat-tab label="{{ 'tables.school' | translate }}">
            <!-- <div class="card"> -->
            <div class="card-content">
              <div class="card-body">
                <div class="media-body">
                  <div
                    class="contenedor"
                    [formGroup]="schoolForm"
                    *ngIf="!isList"
                  >
                    <input
                      matInput
                      [hidden]="true"
                      [formControlName]="'id'"
                      type="text"
                      placeholder="id"
                    />
                    <mat-form-field>
                      <input
                        matInput
                        required
                        [formControlName]="'name'"
                        type="text"
                        placeholder="{{ 'inputs.name' | translate }}"
                      />
                    </mat-form-field>

                    <!-- <mat-form-field appearance="legacy">
                        <mat-label>{{ 'inputs.users' | translate }}</mat-label>
                        <mat-select matNativeControl [formControlName]="'users'">
                          <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                            {{user.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field>
                        <input matInput required [formControlName]="'email'" type="email"
                          placeholder="{{ 'inputs.email_contact' | translate }}">
                      </mat-form-field> -->

                    <mat-checkbox
                      [formControlName]="'tpv_payment'"
                      [color]="'primary'"
                      >{{ "inputs.tpv_payment" | translate }}
                    </mat-checkbox>

                    <mat-form-field appearance="legacy">
                      <mat-label>{{ "inputs.language" | translate }}</mat-label>
                      <mat-select
                        matNativeControl
                        required
                        [formControlName]="'language'"
                      >
                        <mat-option value="es">{{
                          "langs.es" | translate
                        }}</mat-option>
                        <mat-option value="cat">{{
                          "langs.cat" | translate
                        }}</mat-option>
                        <mat-option value="en">{{
                          "langs.en" | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="columns">
                      <mat-label *ngIf="selectedFiles; else newFile">{{
                        selectedFiles.item(0).name
                      }}</mat-label>
                      <ng-template #newFile>
                        <mat-label>{{
                          "inputs.choose_image" | translate
                        }}</mat-label>
                      </ng-template>
                      <input matInput disabled />
                      <button
                        mat-icon-button
                        matSuffix
                        (click)="fileInput.click()"
                      >
                        <mat-icon>attach_file</mat-icon>
                      </button>
                      <input
                        hidden
                        (change)="selectFile($event)"
                        #fileInput
                        type="file"
                        id="file"
                        accept="{{ type_accept }}"
                      />
                    </mat-form-field>

                    <mat-form-field appearance="legacy">
                      <mat-label>{{
                        "inputs.template.new_photo" | translate
                      }}</mat-label>
                      <mat-select
                        matNativeControl
                        [formControlName]="'template_new_photo'"
                      >
                        <mat-option
                          *ngFor="let template of templates_new_photo"
                          [value]="template.id"
                        >
                          {{ template.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{
                        "inputs.template.reminder" | translate
                      }}</mat-label>
                      <mat-select
                        matNativeControl
                        [formControlName]="'template_reminder'"
                      >
                        <mat-option
                          *ngFor="let template of templates_reminder"
                          [value]="template.id"
                        >
                          {{ template.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{
                        "inputs.template.order" | translate
                      }}</mat-label>
                      <mat-select
                        matNativeControl
                        [formControlName]="'template_order'"
                      >
                        <mat-option
                          *ngFor="let template of templates_order"
                          [value]="template.id"
                        >
                          {{ template.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{
                        "inputs.yearperiods" | translate
                      }}</mat-label>
                      <mat-select
                        matNativeControl
                        [formControlName]="'yearperiods'"
                        (selectionChange)="onYearperiodChange($event)"
                      >
                        <mat-option
                          *ngFor="let yearperiod of yearperiods"
                          [value]="yearperiod.id"
                        >
                          {{ yearperiod.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="legacy">
                      <mat-label>{{ "inputs.catalogs" | translate }}</mat-label>
                      <mat-select
                        matNativeControl
                        [formControlName]="'catalogs'"
                      >
                        <mat-option
                          *ngFor="let catalogue of catalogs"
                          [value]="catalogue.id"
                        >
                          {{ catalogue.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        required
                        [formControlName]="'lab_school_id'"
                        type="text"
                        placeholder="{{ 'inputs.lab_school_id' | translate }}"
                      />
                    </mat-form-field>
                    <!-- <mat-checkbox [formControlName] ="'downloadable'" [color]="'primary'">{{ 'inputs.downloadable' | translate }}</mat-checkbox> -->

                    <br />
                    <div>
                      <mat-checkbox
                        [formControlName]="'no_order'"
                        [color]="'primary'"
                        [matTooltip]="
                          !yearperiodActive
                            ? 'The selected yearperiod is not active'
                            : ''
                        "
                        matTooltipPosition="above"
                        >{{ "inputs.no_order" | translate }}
                      </mat-checkbox>
                    </div>

                    <mat-form-field
                      *ngIf="schoolForm.value.no_order || !yearperiodActive"
                    >
                      <input
                        matInput
                        required
                        [formControlName]="'no_order_txt'"
                        type="text"
                        placeholder="{{ 'inputs.no_order_txt' | translate }}"
                      />
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="schoolForm.value.no_order || !yearperiodActive"
                    >
                      <input
                        matInput
                        required
                        [formControlName]="'no_order_txt_cat'"
                        type="text"
                        placeholder="{{
                          'inputs.no_order_txt_cat' | translate
                        }}"
                      />
                    </mat-form-field>
                    <mat-form-field
                      *ngIf="schoolForm.value.no_order || !yearperiodActive"
                    >
                      <input
                        matInput
                        required
                        [formControlName]="'no_order_txt_en'"
                        type="text"
                        placeholder="{{ 'inputs.no_order_txt_en' | translate }}"
                      />
                    </mat-form-field>

                    <br />
                    <mat-checkbox
                      [formControlName]="'notification'"
                      [color]="'primary'"
                      >{{ "inputs.notification" | translate }}
                    </mat-checkbox>
                    <mat-form-field *ngIf="schoolForm.value.notification">
                      <input
                        matInput
                        required
                        [formControlName]="'notification_txt'"
                        type="text"
                        placeholder="{{
                          'inputs.notification_txt' | translate
                        }}"
                      />
                    </mat-form-field>
                    <mat-form-field *ngIf="schoolForm.value.notification">
                      <input
                        matInput
                        required
                        [formControlName]="'notification_txt_cat'"
                        type="text"
                        placeholder="{{
                          'inputs.notification_txt_cat' | translate
                        }}"
                      />
                    </mat-form-field>
                    <mat-form-field *ngIf="schoolForm.value.notification">
                      <input
                        matInput
                        required
                        [formControlName]="'notification_txt_en'"
                        type="text"
                        placeholder="{{
                          'inputs.notification_txt_en' | translate
                        }}"
                      />
                    </mat-form-field>
                    <!-- <mat-form-field appearance="legacy">
                                  <mat-label>{{ 'inputs.catalogue' | translate }}</mat-label>
                                  <mat-select matNativeControl [formControlName]="'catalogue'">
                                    <mat-option *ngFor="let catalogue of catalogs" [value]="catalogue.id">
                                      {{catalogue.name}}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </mat-tab>
          <mat-tab *ngIf="!isNew" label="{{ 'menu.stage' | translate }}">
            <app-stages></app-stages>
          </mat-tab>
          <mat-tab *ngIf="!isNew" label="{{ 'menu.grade' | translate }}">
            <app-grades (changeTab)="changeIndexSelected($event)"></app-grades>
          </mat-tab>
          <!-- <mat-tab label="{{ 'menu.line' | translate }}"><app-lines></app-lines></mat-tab> -->
        </mat-tab-group>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="!isList && !isNew">
    <div class="card-content">
      <div class="card-body">
        <app-relationshipschoolusers></app-relationshipschoolusers>
      </div>
    </div>
  </div>
  <div class="float-button-container" *ngIf="isList">
    <button
      mat-fab
      color="primary"
      aria-label="add"
      (click)="newSchool()"
      *ngIf="role == 'superadmin' || role == 'admin'"
    >
      <mat-icon>plus_one</mat-icon>
    </button>
  </div>
  <div class="float-button-container" *ngIf="!isList">
    <button
      mat-fab
      color="primary"
      aria-label="save"
      (click)="saveSchool()"
      *ngIf="role == 'superadmin' || role == 'admin'"
    >
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>
